module.exports = __webpack_public_path__ + "img/truck-green.c4cebd85.svg";